import { TOKEN_KEY } from "@/app/constants/appkeys";
import { BASE_URL } from "@/app/constants/urls";
import { SessionStorage } from "@/app/utils/storage";

export enum RequestTypes {
  post = "post",
  put = "put",
  patch = "patch",
  delete = "delete",
  get = "get",
}
interface HeaderAddOn {
  noAuth?: boolean;
}

interface RequestDataType {
  data?: object | any;
  noAuth?: boolean;
}

export async function getHeaders(addOn: HeaderAddOn) {
  const { noAuth = false } = addOn;
  const headers: any = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (!noAuth) {
    const token = SessionStorage?.get(TOKEN_KEY);
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }

  return headers;
}

export const post = async (endpoint: string, props: RequestDataType) => {
  const { data, noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });

  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.post,
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};

export const get = async (endpoint: string, props: RequestDataType) => {
  const { noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });

  // Use `cache: "no-store"` so that each request fetches fresh data from
  // the Laravel backend. This keeps SEO content (HTML + meta tags) in sync
  // with the latest data while still allowing the backend or upstream
  // proxies to apply their own HTTP-level caching.
  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.get,
    headers: headers,
    cache: "no-store",
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};
export const del = async (endpoint: string, props: RequestDataType) => {
  const { noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });
  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.delete,
    headers: headers,
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};
export const put = async (endpoint: string, props: RequestDataType) => {
  const { data, noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });

  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.put,
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};
export const patch = async (endpoint: string, props: RequestDataType) => {
  const { data, noAuth = false } = props;
  const headers = await getHeaders({ noAuth: noAuth });
  return fetch(BASE_URL + endpoint, {
    method: RequestTypes.patch,
    headers: headers,
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error(error, "error");
    });
};
